'use strict';


//Model name
angular.module('dash.webglMap', [])

//Angular components
.controller('WebglMapController', require('./WebglMapController'))
.directive('webglMap', require('./WebglMapDirective'))

//Flux components
.factory('WebglMapActions', require('./WebglMapActions'))
.factory('WebglMapStore', require('./WebglMapStore'))

//Bind store to actions through init method
.run(['WebglMapStore', function (WebglMapStore) {
  WebglMapStore.init();
}]);



// WEBPACK FOOTER //
// ./src/app/dash/webglMap/index.js